import { DefaultTabKey } from 'shared/content/tab/types';
import { LazyMapTab } from 'pages/tab.map/ui/components/lazy';
import { Capability } from 'console/device/device-capability';
import { DevicePermission } from 'console/device/device_ts';
export const mapTabDefinition = {
    key: DefaultTabKey.map,
    title: 'Карта',
    iconclass: 'ui-icon-tab-map',
    should_appear_depends_on: ['capabilities', 'access'],
    should_appear: (device) => device?.has_capability(Capability.has_gps) &&
        (device?.has_access(DevicePermission.view_state) ||
            device?.has_access(DevicePermission.view_gps)),
    render: LazyMapTab,
};
